export default __webpack_public_path__ + "static/media/blog-img72.dcf39342.jpg";